import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from '@ionic/react'
import { useQueryClient } from '@tanstack/react-query'

import { useLoyaltyRestrictions } from '../../../../auth/account/utils'
import { usePairedLoyalty } from '../../../../check-in/paired/queries'
import { useStationClientId } from '../../../../check-in/paired/utils'
import { LoyaltyRedemptionDetail } from '../../../../loyalty/components/loyalty-redemption-detail'
import { useApplyClientRewards } from '../../../../marketing/customer-opt-in/mutations'
import { useUpdateClientStation } from '../../../../check-in/paired/mutations'
import { checkInQueryKeys } from '../../../../check-in/paired/queries'

import type { ApplyLoyaltyReward } from '../../../../loyalty/loyalty.schema'

function LoyaltyDetailPage() {
  const queryClient = useQueryClient()
  const stationClientId = useStationClientId()

  const loyaltyRestrictions = useLoyaltyRestrictions()

  const pairedLoyalty = usePairedLoyalty()
  const applyRewards = useApplyClientRewards()
  const { mutate: updateStation } = useUpdateClientStation()
  const router = useIonRouter()

  function handleApplyRewards(
    rewards: Array<ApplyLoyaltyReward>,
    options?: { redeemEarly: boolean }
  ) {
    applyRewards.mutate({ rewards, options })
  }

  function handleFinish() {
    if (stationClientId)
      return updateStation(
        { objectId: stationClientId, status: 'completed' },
        { onSuccess: () => redirect() }
      )

    redirect()
  }
  function redirect() {
    queryClient.invalidateQueries({
      queryKey: checkInQueryKeys.clientStations(),
      exact: false,
    })

    router.push('/check-in/paired/admin/home', 'back', 'pop')
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Redeem Rewards</IonTitle>
          <IonButtons slot="end">
            <IonButton color="yellow" fill="solid" onClick={handleFinish}>
              Finish
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <>
          {pairedLoyalty.loyalty ? (
            <LoyaltyRedemptionDetail
              data={pairedLoyalty.loyalty}
              checkInMethod={{
                email: pairedLoyalty.loyalty.checkedInEmail,
                phone: pairedLoyalty.loyalty.checkedInPhone,
              }}
              // disabled={loyalty.isLoading}
              onApplyRewards={handleApplyRewards}
              restrictions={loyaltyRestrictions}
            />
          ) : pairedLoyalty.status === 'error' ? (
            <div>
              <p>Error: </p>
              {pairedLoyalty.loyaltyError ? (
                <p>
                  {pairedLoyalty.loyaltyError instanceof Error
                    ? pairedLoyalty.loyaltyError.message
                    : 'Unknown Error.'}
                </p>
              ) : null}
              {pairedLoyalty.stationClientError ? (
                <p>
                  {pairedLoyalty.stationClientError instanceof Error
                    ? pairedLoyalty.stationClientError.message
                    : 'Unknown Error.'}
                </p>
              ) : null}
            </div>
          ) : (
            <IonLoading message="Loading Rewards..." isOpen />
          )}
        </>
      </IonContent>
    </IonPage>
  )
}

export { LoyaltyDetailPage }
